export default {
  loading: false,
  activeStep: 0,
  appConfigV2: {
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/store/states.js